import { TabPanel } from '@mui/lab';
import { styled } from '@nexelem/deprecated-theme';
import { useAppBarHeight } from '@nexelem/appbar';

type InternalDetailsPanelProps = {
  readonly height?: `${number}px` | `${number}%` | 'auto' | string;
};
const InternalDetailsPanel = ({ height }: InternalDetailsPanelProps) => {
  const { appBarHeight } = useAppBarHeight();
  return {
    height: height || `calc(100% - ${appBarHeight}px)`,
    padding: '0',
  };
};

export const DetailsPanel = styled(TabPanel)(InternalDetailsPanel);
